  <!-- Breadcrumb -->
  <div class="content-breadcrumb div-breadcrumb">
    <em class="fa fa-pie-chart icon-breadcrumb"></em>
    <span class="text-breadcrumb">Estatísticas</span>
  </div>

  <div class="container-fluid">
    <div class="row mt-3">
      <div class="col-12">
         <form (ngSubmit)="filtrarGraficos()" #filterForm="ngForm" autocomplete="off">
          <div class="row pr-3">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mb-1 pr-0">
              <!-- Campo para informar o prestador -->
              <ngx-select [items]="listaPrestadores" optionValueField="id" optionTextField="nome"
                  noResultsFound="Nenhum resultado encontrado" placeholder="Relação de Prestadores"
                  name="prestador" [(ngModel)]="filters.prestador" #prestador="ngModel">
              </ngx-select>
            </div>
            <!-- <div class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 mb-1 pr-0">
              <ngx-select [items]="listaAnos" optionValueField="nome" optionTextField="nome"
                  noResultsFound="Nenhum resultado encontrado" placeholder="Ano Atendimento"
                  name="ano" [(ngModel)]="filters.ano" #ano="ngModel">
              </ngx-select>
            </div> -->
            <!-- Campo para informar o período -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-1 pr-0">
              <input class="form-control datepicker-atendimento" placeholder="Período" bsDaterangepicker
              (bsValueChange)="setPeriodDateFilter($event)" value="{{ getFormatarPeriodoFiltro() }}"
              [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, containerClass: 'theme-dark-blue', selectFromOtherMonth: true, showWeekNumbers: false }" />
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-1 pr-0">
              <!-- Botão buscar os dados -->
              <button type="submit" class="btn btn-primary rounded mr-1">
                <i class="fa fa-search"></i> Buscar
              </button>

              <!-- Botão de limpar -->
              <button class="btn btn-secondary rounded ms-1" type="button" (click)="limparFiltros();">
                <i class="fa fa-times-circle"></i>&nbsp; Limpar
              </button>
            </div>
          </div>
          </form>
        </div>
    </div>

    <!-- Bloco de gráficos -->
    <div style="text-align:center">
      <div class="row">
        <!-- Gráfico dos atendimentos mensais - valores monetários -->
        <div class="col-md-12 col-lg-8 mb-4">
          <app-card titleCard="Atendimentos Mensais R$">
            <app-chart [data]="chartDataMesValores"></app-chart>
          </app-card>
        </div>

        <!-- Gráfico dos atendimentos anuais - valores monetários -->
        <div class="col-md-12 col-lg-4 mb-4">
          <app-card titleCard="Atendimentos Anuais R$">
            <app-chart [data]="chartDataAnoValores"></app-chart>
          </app-card>
        </div>
      </div>

      <div class="row">
        <!-- Gráfico dos atendimentos mensais - quantidade -->
        <div class="col-md-12 col-lg-8 mb-4">
          <app-card titleCard="Atendimentos Mensais - Quantidade">
            <app-chart [data]="chartDataMesQtde"></app-chart>
          </app-card>
        </div>

        <!-- Gráfico dos atendimentos anuais - quantidade -->
        <div class="col-md-12 col-lg-4 mb-4">
          <app-card titleCard="Atendimentos Anuais - Quantidade">
            <app-chart [data]="chartDataAnoQtde"></app-chart>
          </app-card>
        </div>
      </div>

      <!-- Gráfico dos atendimentos acumulados - valores monetários -->
      <div class="d-flex align-items-center justify-content-center">
        <div class="col-12 col-md-8 mb-4">
          <app-card titleCard="Atendimentos Acumulados R$">
            <app-chart [data]="chartDataAcumulado"></app-chart>
          </app-card>
        </div>
      </div>
    </div>
  </div>
